module.exports = __webpack_public_path__ + "images/account_setups/icon-project-timeline-view-c529ca563ef0603d6f9afb1c723bc704.png";